import { render } from "./PdvDistanceFilter.vue?vue&type=template&id=036645ef&scoped=true"
import script from "./PdvDistanceFilter.vue?vue&type=script&lang=js"
export * from "./PdvDistanceFilter.vue?vue&type=script&lang=js"

import "./PdvDistanceFilter.vue?vue&type=style&index=0&id=036645ef&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-036645ef"]])

export default __exports__